import { render, staticRenderFns } from "./OrgCard.vue?vue&type=template&id=22087b6c&scoped=true&"
import script from "./OrgCard.vue?vue&type=script&lang=ts&"
export * from "./OrgCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrgCard.vue?vue&type=style&index=0&id=22087b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22087b6c",
  null
  
)

export default component.exports